/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MlsId
 */
export interface MlsId {
}

/**
 * Check if a given object implements the MlsId interface.
 */
export function instanceOfMlsId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MlsIdFromJSON(json: any): MlsId {
    return MlsIdFromJSONTyped(json, false);
}

export function MlsIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): MlsId {
    return json;
}

export function MlsIdToJSON(value?: MlsId | null): any {
    return value;
}

